import { lazy } from 'react';

export const authenticatedRoutes = [
	{
		path: '/geofence',
		element: lazy(() => import('./modules/geofence')),
		sidebar: true,
		header: true,
		accessKey: 'geo_fences',
		view: true,
		all: true
	},
	{
		path: '/geofence/add',
		element: lazy(() => import('./modules/geofence/components/GeofenceAdd')),
		sidebar: true,
		header: true,
		accessKey: 'geo_fences',
		view: false,
		all: true
	},
	{
		path: '/geofence/:id',
		element: lazy(() => import('./modules/geofence/components/GeofenceAdd')),
		sidebar: true,
		header: true,
		accessKey: 'geo_fences',
		view: false,
		all: true
	},
	// {
	// 	path: '/pricing',
	// 	element: lazy(() => import('./modules/pricing')),
	// 	sidebar: true,
	// 	header: true
	// },
	// {
	// 	path: '/pricing/add',
	// 	element: lazy(() => import('./modules/pricing/components/PricingAdd')),
	// 	sidebar: true,
	// 	header: true
	// },
	{
		path: '/timeslots',
		element: lazy(() => import('./modules/timeslots')),
		sidebar: true,
		header: true,
		accessKey: 'time_slots',
		view: true,
		all: true
	},
	{
		path: '/timeslots/add',
		element: lazy(() => import('./modules/timeslots/components/TimeslotsAdd')),
		sidebar: true,
		header: true,
		accessKey: 'time_slots',
		view: false,
		all: true
	},
	{
		path: '/timeslots/:id',
		element: lazy(() => import('./modules/timeslots/components/TimeslotsAdd')),
		sidebar: true,
		header: true,
		accessKey: 'time_slots',
		view: false,
		all: true
	},
	{
		path: '/holidays',
		element: lazy(() => import('./modules/holidays')),
		sidebar: true,
		header: true,
		accessKey: 'holidays',
		view: true,
		all: true
	},
	{
		path: '/holidays/add',
		element: lazy(() => import('./modules/holidays/components/HolidayAdd')),
		sidebar: true,
		header: true,
		accessKey: 'holidays',
		view: false,
		all: true
	},
	{
		path: '/holidays/:id',
		element: lazy(() => import('./modules/holidays/components/HolidayAdd')),
		sidebar: true,
		header: true,
		accessKey: 'holidays',
		view: false,
		all: true
	},
	{
		path: '/sub-admins',
		element: lazy(() => import('./modules/sub-admins')),
		sidebar: true,
		header: true,
		accessKey: 'sub_admins',
		view: true,
		all: true
	},
	{
		path: '/sub-admins/add',
		element: lazy(() => import('./modules/sub-admins/components/SubAdminAdd')),
		sidebar: true,
		header: true,
		accessKey: 'sub_admins',
		view: false,
		all: true
	},
	{
		path: '/roles-permissions',
		element: lazy(() => import('./modules/roles-permissions')),
		sidebar: true,
		header: true,
		accessKey: 'roles_and_permission',
		view: true,
		all: true
	},
	{
		path: '/roles-permissions/add',
		element: lazy(
			() => import('./modules/roles-permissions/components/RolesPermissionsAdd')
		),
		sidebar: true,
		header: true,
		accessKey: 'roles_and_permission',
		view: false,
		all: true
	},
	{
		path: '/roles-permissions/edit/:id',
		element: lazy(
			() => import('./modules/roles-permissions/components/RolesPermissionsAdd')
		),
		sidebar: true,
		header: true,
		accessKey: 'roles_and_permission',
		view: false,
		all: true
	},
	{
		path: '/notifications',
		element: lazy(() => import('./modules/notifications')),
		sidebar: true,
		header: true,
		accessKey: 'notifications',
		view: true,
		all: true
	},
	{
		path: '/notifications/send-new',
		element: lazy(() => import('./modules/notifications/components/SendNewNotification')),
		sidebar: true,
		header: true,
		accessKey: 'notifications',
		view: false,
		all: true
	},
	{
		path: '/app-settings',
		element: lazy(() => import('./modules/app-settings')),
		sidebar: true,
		header: true,
		accessKey: 'app_settings',
		view: true,
		all: true
	},
	{
		path: '/cms',
		element: lazy(() => import('./modules/cms')),
		sidebar: true,
		header: true,
		accessKey: 'cms_pages',
		view: true,
		all: true
	},
	{
		path: '/cms/edit/:id',
		element: lazy(() => import('./modules/cms/components/CmsEdit')),
		sidebar: true,
		header: true,
		accessKey: 'cms_pages',
		view: false,
		all: true
	},

	{
		path: '/my-profile/edit',
		element: lazy(() => import('./modules/my-profile/components/ProfileEdit')),
		sidebar: true,
		header: true,
		accessKey: 'my_profile',
		view: false,
		all: true
	},
	{
		path: '/pending-orders',
		element: lazy(() => import('./modules/orders/pending-orders')),
		sidebar: false,
		header: true,
		accessKey: 'pending_orders',
		view: true,
		all: true
	},
	{
		path: '/pending-orders/view/:id',
		element: lazy(
			() => import('./modules/orders/pending-orders/components/PendingOrdersView')
		),
		sidebar: false,
		header: true,
		accessKey: 'pending_orders',
		view: true,
		all: true
	},

	{
		path: '/orders-history',
		element: lazy(() => import('./modules/orders/orders-history')),
		sidebar: false,
		header: true,
		accessKey: 'order_history',
		view: true,
		all: true
	},
	{
		path: '/orders-history/view/:id',
		element: lazy(
			() => import('./modules/orders/orders-history/components/OrdersHistoryView')
		),
		sidebar: false,
		header: true,
		accessKey: 'order_history',
		view: true,
		all: true
	},
	{
		path: '/ongoing-orders',
		element: lazy(() => import('./modules/orders/ongoing-orders')),
		sidebar: false,
		header: true,
		accessKey: 'ongoing_orders',
		view: true,
		all: true
	},
	{
		path: '/ongoing-orders/view/:id',
		element: lazy(
			() => import('./modules/orders/ongoing-orders/components/OngoingOrdersView')
		),
		sidebar: false,
		header: true,
		accessKey: 'ongoing_orders',
		view: true,
		all: true
	},
	{
		path: '/vendors',
		element: lazy(() => import('./modules/vendors')),
		sidebar: false,
		header: true,
		accessKey: 'vendor',
		view: true,
		all: true
	},
	{
		path: '/vendors/add',
		element: lazy(() => import('./modules/vendors/components/VendorsAdd')),
		sidebar: false,
		header: true,
		accessKey: 'vendor',
		view: false,
		all: true
	},
	{
		path: '/vendors/view/:id',
		element: lazy(() => import('./modules/vendors/components/VendorsView')),
		sidebar: false,
		header: true,
		accessKey: 'vendor',
		view: true,
		all: true
	},
	{
		path: '/vendors/:id',
		element: lazy(() => import('./modules/vendors/components/VendorsAdd')),
		sidebar: false,
		header: true,
		accessKey: 'vendor',
		view: false,
		all: true
	},
	{
		path: '/drivers',
		element: lazy(() => import('./modules/drivers')),
		sidebar: false,
		header: true,
		accessKey: 'drivers',
		view: true,
		all: true
	},
	{
		path: '/drivers/add',
		element: lazy(() => import('./modules/drivers/components/DriversAdd')),
		sidebar: false,
		header: true,
		accessKey: 'drivers',
		view: false,
		all: true
	},
	{
		path: '/drivers/add/:id',
		element: lazy(() => import('./modules/drivers/components/DriversAdd')),
		sidebar: false,
		header: true,
		accessKey: 'drivers',
		view: false,
		all: true
	},
	{
		path: '/drivers/view/:id',
		element: lazy(() => import('./modules/drivers/components/DriversView')),
		sidebar: false,
		header: true,
		accessKey: 'drivers',
		view: true,
		all: true
	},
	{
		path: '/users',
		element: lazy(() => import('./modules/users')),
		sidebar: false,
		header: true,
		accessKey: 'users',
		view: true,
		all: true
	},
	{
		path: '/users/add',
		element: lazy(() => import('./modules/users/components/UsersAdd')),
		sidebar: false,
		header: true,
		accessKey: 'users',
		view: false,
		all: true
	},
	{
		path: '/users/view/:id',
		element: lazy(() => import('./modules/users/components/UsersView')),
		sidebar: false,
		header: true,
		accessKey: 'users',
		view: true,
		all: true
	},

	{
		path: '/reports',
		element: lazy(() => import('./modules/reports')),
		sidebar: false,
		header: true,
		accessKey: 'reports',
		view: true,
		all: true
	},
	// {
	// 	path: '/reports/add',
	// 	element: lazy(() => import('./modules/reports/components/ReportsAdd')),
	// 	sidebar: false,
	// 	header: true,
	// 	accessKey: 'reports',
	// 	view: false,
	// 	all: true
	// },

	{
		path: '/products',
		element: lazy(() => import('./modules/product-settings/products/index')),
		sidebar: false,
		header: true,
		accessKey: 'product',
		view: true,
		all: true
	},
	{
		path: '/products/add',
		element: lazy(
			() => import('./modules/product-settings/products/components/ProductsAdd')
		),
		sidebar: false,
		header: true,
		accessKey: 'product',
		view: false,
		all: true
	},
	{
		path: '/products/:id',
		element: lazy(
			() => import('./modules/product-settings/products/components/ProductsAdd')
		),
		sidebar: false,
		header: true,
		accessKey: 'product',
		view: false,
		all: true
	},
	// {
	// 	path: '/products/add2',
	// 	element: lazy(
	// 		() => import('./modules/product-settings/products/components/ProductsAdd2')
	// 	)
	// },

	// {
	// 	path: '/cylinder-size',
	// 	element: lazy(() => import('./modules/product-settings/cylinder-size')),
	// 	sidebar: true,
	// 	header: true
	// },
	// {
	// 	path: '/cylinder-size/add',
	// 	element: lazy(
	// 		() => import('./modules/product-settings/cylinder-size/components/CylinderSizeAdd')
	// 	),
	// 	sidebar: true,
	// 	header: true
	// },
	{
		path: '/map',
		element: lazy(() => import('./modules/map/index')),
		sidebar: false,
		header: true,
		accessKey: 'map',
		view: true,
		all: true
	},
	{
		path: '/email-templates',
		element: lazy(() => import('./modules/email-templates')),
		sidebar: true,
		header: true,
		accessKey: 'email_templates',
		view: true,
		all: true
	},
	{
		path: '/email-templates/add/:id',
		element: lazy(() => import('./modules/email-templates/components/EmailAdd')),
		sidebar: true,
		header: true,
		accessKey: 'email_templates',
		view: false,
		all: true
	},
	{
		path: '/email-templates/view/:id',
		element: lazy(() => import('./modules/email-templates/components/EmailView')),
		sidebar: true,
		header: true,
		accessKey: 'email_templates',
		view: true,
		all: true
	},
	{
		path: '/contact-us',
		element: lazy(() => import('./modules/contact-us')),
		sidebar: true,
		header: true,
		accessKey: 'contact_us',
		view: true,
		all: true
	},

	{
		path: '/contact-us/:id',
		element: lazy(() => import('./modules/contact-us/components/ContactUsAdd')),
		sidebar: true,
		header: true,
		accessKey: 'contact_us',
		view: false,
		all: true
	}
];

export const WithOutPermissionRoutes = [
	{
		path: '/dashboard',
		element: lazy(() => import('./modules/dashboard')),
		sidebar: false,
		header: true
		// accessKey: 'dashboard',
		// view: true,
		// all: true
	},
	{
		path: '/pageNotFound',
		element: lazy(() => import('./shared/components/PageNotFound')),
		sidebar: false,
		header: false
	},
	{
		path: '/*',
		element: lazy(() => import('./shared/components/PageNotFound')),
		sidebar: false,
		header: false
	},
	{
		path: '/change-password',
		element: lazy(() => import('./modules/change-password')),
		sidebar: true,
		header: true
		// accessKey: 'change_password',
		// view: true,
		// all: true
	},
	{
		path: '/my-profile',
		element: lazy(() => import('./modules/my-profile')),
		sidebar: true,
		header: true
		// accessKey: 'my_profile',
		// view: true,
		// all: true
	},

	{
		path: '/settlement',
		element: lazy(() => import('./modules/settlement')),
		sidebar: true,
		header: true
	},
	{
		path: '/delay-orders',
		element: lazy(() => import('./modules/orders/delay-orders')),
		sidebar: true,
		header: true
	}, //delay-orders/view
	{
		path: '/delay-orders/view/:id',
		element: lazy(
			() => import('./modules/orders/delay-orders/components/DelayOrdersView')
		),
		sidebar: false,
		header: true
	},
	{
		path: '/subscription-plan',
		element: lazy(
			() => import('./modules/subscription-plan/index')
		),
		sidebar: true,
		header: true
	},
	{
		path: '/payment',
		element: lazy(
			() => import('./modules/payment/index')
		),
		sidebar: false,
		header: true
	},	
];
